<template>
  <el-select v-model="v" filterable default-first-option remote placeholder="请选择品牌" :size="size"
             clearable>
    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"/>
  </el-select>
</template>

<script>
import {brandOption} from "@/api/brand";

export default {
  name: "SelectBrand",
  props: ['value', 'size'],
  data() {
    return {
      v: null,
      options: [],
    }
  },
  watch: {
    v(_) {
      this.$emit('update:value', _)
      const obj = this.options.find(item => {
        return item.value === _
      })
      if (obj) {
        this.$emit('update:name', obj.label)
      }
      this.$nextTick(() => {
        this.$emit('change')
      })
    },
    value: {
      immediate: true,
      handler(_) {
        this.v = _ ? parseInt(_ + '') : ''
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const response = await brandOption()
      this.options = response.model || []
    }
  }
}
</script>

<style scoped>

</style>
